export default "__VITE_ASSET__DNVQumj___"